import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

interface IconProps {
  firstName: string;
  lastName: string;
  profilePicture: string;
}

const ProfileIcon = ({ firstName, lastName, profilePicture }: IconProps) => {
  const ico = profilePicture ? (
    <div className={cx('profpic')} style={{ backgroundImage: `url(${profilePicture})` }} />
  ) : (
    <div className={cx('circle')}>
      <h3>{firstName.charAt(0) + lastName.charAt(0)}</h3>
    </div>
  );

  return (
    <span
      className={cx('icon', 'd-none d-md-block mr-3', {
        large: true,
      })}
    >
      {ico}
    </span>
  );
};

export default ProfileIcon;
